<template>
  <div class="flex my-2">
    <select
      v-model="selectedProject"
      class="p-2 bg-gray-200 rounded"
    >
      <option
        :value="null"
      >
        {{ $t('Any Project', 'Any Project') }}
      </option>
      <option
        v-for="project in projects"
        :key="project.id"
        :value="project.id"
      >
        {{ project.name }}
      </option>
    </select>
    <select
      v-model="selectedAuthor"
      class="ml-2 p-2 bg-gray-200 rounded"
    >
      <option
        :value="null"
      >
        {{ $t('Any Author', 'Any Author') }}
      </option>
      <option
        v-for="author in authors"
        :key="author.id"
        :value="author.id"
      >
        {{ author.fullName }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionNames } from '@/store'
export default {
  computed: {
    ...mapState({
      projects: state => state.projects.projects,
      authors: state => state.customLabels.authors
    }),
    selectedProject: {
      get () {
        return this.$store.state.customLabels.projectFilter
      },
      set (selectedId) {
        this.$store.dispatch(actionNames.SET_CUSTOM_LABEL_PROJECT_FILTER, selectedId)
      }
    },
    selectedAuthor: {
      get () {
        return this.$store.state.customLabels.authorFilter
      },
      set (selectedId) {
        this.$store.dispatch(actionNames.SET_CUSTOM_LABEL_AUTHOR_FILTER, selectedId)
      }
    }
  }
}
</script>
